import { render, staticRenderFns } from "./menu5_active_learning.vue?vue&type=template&id=f1a5965e&scoped=true"
import script from "./menu5_active_learning.vue?vue&type=script&lang=js"
export * from "./menu5_active_learning.vue?vue&type=script&lang=js"
import style0 from "./menu5_active_learning.vue?vue&type=style&index=0&id=f1a5965e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a5965e",
  null
  
)

export default component.exports